<template>
  <v-card style="padding:24px;border-top: 4px solid #f74e50;opacity: 0.91;">
    <v-btn icon @click="$emit('close')" style="position:absolute;top:0px;right:0px">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <div class="title" style="margin-bottom:12px;    font-weight: 600;">{{article.title}}</div>

    <div v-html="article.data.content"></div>
  </v-card>
</template>

<script>
import { getInfoView } from "@/api/info";
export default {
  props: ["nav", "navData"],
  data: () => ({
    article: { data: {} }
  }),
  watch: {
    // navData: newNavData => {
    //   console.log("newNavData", newNavData);
    //   this.getArticle(newNavData.params.id);
    // }
    navData: function(newNavData, oldNavData) {
      this.getArticle(newNavData.params.id);
    }
  },
  methods: {
    getArticle(id) {
      getInfoView(id).then(res => {
        this.article = res.data.info;
      });
    }
  },
  mounted() {
    getInfoView(this.navData.params.id).then(res => {
      this.article = res.data.info;
    });
  }
};
</script>
<style lang="scss">
</style>
